export default __webpack_public_path__ + "static/media/save.6b090268.png";